import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class Skip<V = any, E = any, C = any> extends Pass<V, E, C> {
    skipped = 0
    constructor(protected source?: AnySourceStream<V, E, C>, protected skipCount?: number) {
        super(source)
    }

    value(value: V) {
        if (this.skipped === this.skipCount) {
            this._value(value)
        } else {
            this.skipped++
        }
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        skip<T = DV>(skipCount: number): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.skip = function <V, E, C>(this: AnySourceStream<V, E, C>, skipCount: number) {
    return new Skip(this, skipCount) // tslint:disable-line:no-invalid-this
}
